import { IPaginationParams, IPaginationResponse } from '../models/interfaces/pagination';
import apiService from './api';
import { ICollaborators, ICollaborator } from "../types/ICollaborators";

export class CollaboratorsService {
  public listCollaborators(params: IPaginationParams): Promise<IPaginationResponse<ICollaborators[]>> {
    return apiService.get('/user', { params });
  }

  public createCollaborator(params: ICollaborator): Promise<void> {
    return apiService.post('/user', { params });
  }

}

const collaboratorsService = new CollaboratorsService();
export default collaboratorsService;
